import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

interface Activity {
  name: string;
  capacityPerDay: number;
}

interface ActivityBreakdownChartProps {
  activities: Activity[];
  totalCapacity: number;
  size?: 'small' | 'large'; // Tamaño del gráfico
}

const COLORS = [
  '#2563EB', // primary blue
  '#16A34A', // success green
  '#CA8A04', // warning yellow
  '#DC2626', // error red
  '#737373', // neutral gray
  '#8B5CF6', // purple
  '#EC4899', // pink
];

const ActivityBreakdownChart: React.FC<ActivityBreakdownChartProps> = ({
  activities,
  totalCapacity,
  size = 'small'
}) => {
  // Transformar datos para el gráfico
  const chartData = activities.map((activity, index) => ({
    name: activity.name,
    value: activity.capacityPerDay,
    percentage: ((activity.capacityPerDay / totalCapacity) * 100).toFixed(1),
    color: COLORS[index % COLORS.length],
  }));

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      return (
        <div className="bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-lg p-3 shadow-lg">
          <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-50">
            {data.name}
          </p>
          <p className="text-xs text-neutral-600 dark:text-neutral-400 mt-1">
            {data.value}h/día ({data.payload.percentage}%)
          </p>
        </div>
      );
    }
    return null;
  };

  const height = size === 'large' ? 'h-80' : 'h-48';
  const outerRadius = size === 'large' ? 100 : 60;

  return (
    <div className={`w-full ${height}`}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ percentage }) => `${percentage}%`}
            outerRadius={outerRadius}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend
            verticalAlign="bottom"
            height={36}
            formatter={(value, entry: any) => (
              <span className="text-xs text-neutral-700 dark:text-neutral-300">
                {value} ({entry.payload.value}h)
              </span>
            )}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ActivityBreakdownChart;
